import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import InvestmentCostsBenefits from "./InvestmentCostsBenefits";

import { selectInvestmentStepData } from "store/user/investment/selectors";
import { setInvestmentStepData } from "store/user/investment/actions";
import { selectProjectCostBenefits, selectCalculatedCostBenefitsValues } from "store/project/selectors";
import { useSideModalScrollToTop } from "hooks";

const InvestmentCalculationStep = ({
    className = "",
    investmentStepData,
    setInvestmentStepData,
    costBenefits,
    costBenefitsValues,
    backButton,
    hitBack,
    backSlideEffect = "",
    setBackSlideEffect,
}) => {
    useSideModalScrollToTop();

    useEffect(() => {
        if (backButton) {
            hitBack();
            setInvestmentStepData({ investmentData: { step: "renderAdequacyStep" } });
        }
    }, [backButton]);

    return (
        <div className={`${className} investment-calculation-step`}>
            <InvestmentCostsBenefits
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                costBenefits={costBenefits}
                costBenefitsValues={costBenefitsValues}
                investmentStepData={investmentStepData}
                setInvestmentStepData={setInvestmentStepData}
            />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    investmentStepData: selectInvestmentStepData,
    costBenefits: selectProjectCostBenefits,
    costBenefitsValues: selectCalculatedCostBenefitsValues,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentCalculationStep);
